import { HostConfigurationDtoToEntity } from "src/app/features/HostConfiguration/services/mappers/HostConfigurationDtoToEntity";
import type { HostConfigurationDto } from "src/app/features/HostConfiguration/types/HostConfigurationDto";
import type { HostConfigurationEntity } from "src/app/features/HostConfiguration/types/HostConfigurationEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const HostConfigurationTableDtoMapper = (
    input: Readonly<ResourcePageDto<HostConfigurationDto>>,
): ResourcePageEntity<HostConfigurationEntity> => {
    return {
        list: input.list ? input.list.map(HostConfigurationDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
